export const HUB_FEATURE_KEYS = [
  { id: 'scheduleviewer', defaultName: 'View schedule' },
  { id: 'scheduleprefs', defaultName: 'Schedule preferences' },
] as const;

export type HubFeatureId = (typeof HUB_FEATURE_KEYS)[number]['id'];

export type HubFeature = {
  id: HubFeatureId;
  enabled: boolean;
};

/** Response shape of GET and PUT /hub/configurations on the hub backend: features keyed by id */
export type HubConfiguration = {
  id: string;
  features: Record<HubFeatureId, Pick<HubFeature, 'enabled'>>;
};
